/**
 * @generated SignedSource<<b97109fbbcd06ed7bd5ea168270ad720>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserNotesDeleteButtonMutation$variables = {
  id: string;
};
export type UserNotesDeleteButtonMutation$data = {
  readonly response: {
    readonly deleteUserNoteId: string | null;
  };
};
export type UserNotesDeleteButtonMutation = {
  response: UserNotesDeleteButtonMutation$data;
  variables: UserNotesDeleteButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleteUserNoteId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNotesDeleteButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteUserNoteResponse",
        "kind": "LinkedField",
        "name": "deleteUserNote",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserNotesDeleteButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteUserNoteResponse",
        "kind": "LinkedField",
        "name": "deleteUserNote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deleteUserNoteId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c365561b7b205bdd77fa00a06881c2da",
    "id": null,
    "metadata": {},
    "name": "UserNotesDeleteButtonMutation",
    "operationKind": "mutation",
    "text": "mutation UserNotesDeleteButtonMutation(\n  $id: ID!\n) {\n  response: deleteUserNote(id: $id) {\n    deleteUserNoteId\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb7298771ec10253d490e85ef61335aa";

export default node;
